
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { componentMode } from './Footer.config';
import { NewsletterData, NewsletterMethods, NewsletterComputed, NewsletterProps } from './Newsletter';
/**
 * `Newsletter Footer` - Newsletter for OneWeb - Newsletter Footer contains a button link which redirects the user to a given url, mostly to a newsletter signup form.
 */

export default ComponentInitializeDispatcher.extend<
  NewsletterData,
  NewsletterMethods,
  NewsletterComputed,
  NewsletterProps
>({
  name: 'owc-newsletter',
  props: {
    newsletter: {
      type: Object,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    titleLabel: function(): string {
      return this.isEdit ? this.componentData?.titleLabel : this.newsletter?.titleLabel;
    },
    submitLabel: function(): string {
      return this.isEdit ? this.componentData?.submitLabel : this.newsletter?.submitLabel;
    },
    descriptionLabel: function(): string {
      return this.isEdit ? this.componentData?.descriptionLabel : this.newsletter?.descriptionLabel;
    },
    actionURL: function(): string {
      return this.isEdit ? this.componentData?.actionURL : this.newsletter?.actionURL;
    },
  },
  methods: {
    customTrackingTrigger() {
      this.handleCustomTracking(this.$el, 'newsletter', 'feature', 'click');
    },
  },
});
